import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { supplierUrls } from "../../URL/ApplicationUrls";
import Supplier from "../Supplier";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddSupplier = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (supplier: Supplier) => {
      return axios.post<number>(supplierUrls.addSupplier.apiUrl, supplier);
    },

    onSuccess: async (response: AxiosResponse<number>) => {
      navigate(supplierUrls.supplierWithId(response.data).uiPath);
      toast.success(`The supplier with the Id ${response.data} has been created`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
